import request from "@/plugins/axios";

export function modifyAppAuthority(appAuthorityId,enableCheckRelease) {
  let data = new URLSearchParams()
  data.append("enableCheckRelease",enableCheckRelease)
  return request.put(`/appAdmin/appAuthority/${appAuthorityId}`,data)
}

export function findAppAuthorityByAppId(appId) {
  let params = new URLSearchParams()
  params.append("appId",appId)
  return request.get("/user/appAuthority",{params})
}
